<template>
    <div>
        <div class="wptop">
            <div class="fxwidth wpheader">
                <div class="hdback" @click="goBack"></div>
                <div class="hdtitle">充值</div>
            </div>
            <div class="headerhd"></div>
        </div>

        <div class="mywrap">
            <div class="mylft"><Left/></div>
            <div class="myrht">
                <div class="mytit">在线充值</div>

                <div class="recharge-brand">
                    <img :src="rechargeVisual" alt="亚讯体育专业赛事研究与权威认证"/>
                    <div class="recharge-copy">
                        <small>YAXUN INTEGRITY GUARANTEE · MEMBER SERVICE</small>
                        <h2>专业研判 · 权威认证 · 诚信保障</h2>
                        <p>平台认证专家观点与真实赛事数据交叉验证，发布记录和赛果均可查，让每一笔球币消费都有清晰依据。</p>
                        <div class="recharge-tags"><span>专业研判</span><span>平台权威认证</span><span>真实赛事数据</span><span>公开赛果核验</span></div>
                        <strong>充值请联系客服</strong>
                        <div class="recharge-guarantee"><i>✓</i><span><b>不中退还全部球币</b><em>收费观点未命中时，按平台规则退还该场所用全部球币</em></span></div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import rechargeVisual from "../../assets/images/yaxun-member-studio-v4.png";
    import Left from "./left";

    export default {
        name: "recharge",
        components: {Left},
        data() {
            return {
                showPopup: false,
                formPath: '',
                rechargeVisual
            }
        },
        activated() {

        },
        methods: {
            goBack(){
                //let that = this
                this.$router.push({
                    path: "/my" //that.formPath === '' ?'/':that.formPath
                })
            }
        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                vm.formPath = form.path
            })
        }
    }
</script>

<style scoped>
    .recharge-brand{position:relative;min-height:470px;margin:24px 28px 32px;overflow:hidden;border:1px solid #e3e8ed;border-left:7px solid #e31b23;border-radius:12px;background:#fff;box-shadow:0 20px 46px rgba(38,55,72,.12)}
    .recharge-brand:after{position:absolute;inset:0;background:linear-gradient(90deg,rgba(255,255,255,.99) 0%,rgba(255,255,255,.96) 38%,rgba(255,255,255,.68) 55%,rgba(255,255,255,.08) 78%);content:""}
    .recharge-brand>img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}
    .recharge-copy{position:relative;z-index:1;width:52%;padding:48px 0 38px 48px;color:#16202b}
    .recharge-copy small{color:#e31b23;font-size:11px;font-weight:900;letter-spacing:.21em}
    .recharge-copy h2{max-width:650px;margin:17px 0 12px;color:#121820;font-size:32px;letter-spacing:.02em}
    .recharge-copy p{max-width:600px;margin:0;color:#536270;font-size:15px;line-height:1.85}
    .recharge-tags{display:flex;flex-wrap:wrap;gap:9px;margin:21px 0}.recharge-tags span{padding:8px 13px;border:1px solid #f1c7c9;border-radius:18px;background:#fff6f6;color:#bd2128;font-size:12px;font-weight:800}
    .recharge-copy strong{display:block;width:max-content;margin-top:22px;padding:13px 22px;border-radius:5px;color:#fff;background:#e31b23;box-shadow:0 8px 22px rgba(227,27,35,.2);font-size:17px}
    .recharge-guarantee{display:flex;width:min(570px,calc(100% - 10px));margin-top:17px;align-items:center;gap:12px;padding:13px 15px;border:1px solid #ecd592;border-radius:7px;background:rgba(255,251,234,.95)}.recharge-guarantee>i{display:flex;width:34px;height:34px;flex:0 0 34px;align-items:center;justify-content:center;border-radius:50%;color:#fff;background:#d29b13;font-size:18px;font-style:normal;font-weight:900}.recharge-guarantee span{display:flex;flex-direction:column}.recharge-guarantee b{color:#9d6900;font-size:18px}.recharge-guarantee em{margin-top:4px;color:#6d6350;font-size:12px;font-style:normal;line-height:1.5}
    @media(max-width:900px){.recharge-brand{min-height:430px}.recharge-copy{width:68%;padding:42px 0 35px 38px}.recharge-copy h2{font-size:28px}}
    @media(max-width:600px){.recharge-brand{min-height:570px;margin:14px}.recharge-brand:after{background:linear-gradient(180deg,rgba(255,255,255,.99) 0,rgba(255,255,255,.96) 65%,rgba(255,255,255,.34) 100%)}.recharge-brand>img{object-position:66% center}.recharge-copy{width:auto;padding:32px 20px}.recharge-copy h2{font-size:25px}.recharge-copy p{font-size:14px}.recharge-copy strong,.recharge-guarantee b{font-size:16px}}
</style>
